import { render } from "./OrderSuccessView.vue?vue&type=template&id=47105d03&scoped=true"
import script from "./OrderSuccessView.vue?vue&type=script&lang=js"
export * from "./OrderSuccessView.vue?vue&type=script&lang=js"

import "./OrderSuccessView.vue?vue&type=style&index=0&id=47105d03&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47105d03"]])

export default __exports__